/* MAX AUTO: public availability only. No customer, PI, payment or seller data. */
(()=>{
  if(window.maxautoAvailabilityLoaded)return;
  window.maxautoAvailabilityLoaded=true;
  const endpoint='https://account.maxkauto.com/api/public/vehicle-status';
  const labels={confirm:'Confirm availability',checking:'Availability being confirmed',in_progress:'Reservation in progress',unavailable:'No longer available'};
  const cache=new Map();let busy=false,timer;
  function render(el,state){
    if(el.dataset.maxautoFallback==='unavailable'&&state==='confirm')state='unavailable';
    if(!Object.hasOwn(labels,state))state='checking';
    el.dataset.state=state;
    el.hidden=el.dataset.maxautoCompact==='true'&&state==='confirm';
    const label=el.querySelector('[data-availability-label]');
    if(label&&label.textContent!==labels[state])label.textContent=labels[state];
    const note=el.querySelector('[data-availability-note]');
    if(note){const text=state==='in_progress'?'A customer is completing the reservation process. Contact us for an update.':state==='unavailable'?'Contact us to find a similar vehicle.':state==='checking'?'Our team will confirm the latest vehicle availability on WhatsApp.':'Please confirm via WhatsApp first.';if(note.textContent!==text)note.textContent=text;}
  }
  async function refresh(force=false){
    if(busy||document.hidden)return;
    const nodes=[...document.querySelectorAll('[data-maxauto-availability]')].filter(el=>/^[1-9][0-9]{0,19}$/.test(el.dataset.maxautoAvailability||''));
    const ids=[...new Set(nodes.map(el=>el.dataset.maxautoAvailability))];
    const pending=ids.filter(id=>force||!cache.has(id)||Date.now()-cache.get(id).at>60000);
    nodes.forEach(el=>{const record=cache.get(el.dataset.maxautoAvailability);if(record)render(el,record.state);});
    if(!pending.length)return;busy=true;
    try{
      for(let i=0;i<pending.length;i+=40){
        const batch=pending.slice(i,i+40);let states;
        try{const response=await fetch(endpoint+'?'+new URLSearchParams({ids:batch.join(',')}),{credentials:'omit',cache:'no-store',referrerPolicy:'no-referrer',signal:AbortSignal.timeout(8000)});if(!response.ok)throw Error();const result=await response.json();if(!Array.isArray(result.items))throw Error();states=new Map(result.items.filter(x=>batch.includes(x.productId)&&Object.hasOwn(labels,x.state)).map(x=>[x.productId,x.state]));if(states.size!==batch.length)throw Error();}
        catch{states=new Map(batch.map(id=>[id,'checking']));}
        batch.forEach(id=>cache.set(id,{state:states.get(id),at:Date.now()}));
        nodes.forEach(el=>{if(batch.includes(el.dataset.maxautoAvailability))render(el,states.get(el.dataset.maxautoAvailability));});
      }
    }finally{busy=false;schedule();}
  }
  const schedule=()=>{clearTimeout(timer);timer=setTimeout(()=>refresh(),150);};
  new MutationObserver(m=>{if(m.some(x=>[...x.addedNodes].some(n=>n.nodeType===1&&(n.matches('[data-maxauto-availability]')||n.querySelector('[data-maxauto-availability]')))))schedule();}).observe(document.documentElement,{childList:true,subtree:true});
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)refresh(true);});
  window.addEventListener('pageshow',()=>refresh(true));
  setInterval(()=>refresh(true),60000);schedule();
})();
